import image from "../../Assets/AIOnDemand/revenue-box.png";
import bgImage from "../../Assets/homev2/vod-bg.png";
import TurnkeyTabs from "./TurnkeyTabs";
const TurnkeyGrowthSolutions = () => {
    return (
        <section
            className="w-full bg-cover overflow-hidden relative  mb-3 lg:mb-10"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="w-full h-full max-w-[1500px] mx-auto px-4 pt-8 md:pt-20 pb-8 lg:pb-20 flex flex-col justify-between items-center">
                <div>
                    <h2 className="text-3xl md:text-5xl lg:text-7xl text-white font-semibold text-center flex items-start justify-center">
                        All-in-one Turnkey Growth Solution
                    </h2>
                </div>
                <div className="w-full h-full md:mt-20  gap-5  flex flex-col lg:grid lg:grid-cols-2">
                    <img src={image} alt="" width="100%" height="100%" loading="lazy" className="max-w-[700px] mt-10 lg:-mt-8 object-contain mb-auto" />
                    <TurnkeyTabs />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 w-full mt-10 text-black">
                    {/* Column 1 */}
                    <div className={`flex flex-col lg:flex-row gap-3 px-4 mx-auto w-full justify-evenly`} >
                        <ul className="flex list-outside ml-8 list-disc flex-col gap-3">
                            <li className="text-lg font-semibold leading-relaxed">
                                Deep personalization cold outreach systems.
                            </li>
                            <li className="text-lg font-semibold leading-relaxed">
                                AI-powered invoice and payment automation (improves cash flow).
                            </li>
                        </ul>
                    </div>

                    {/* Column 2 */}
                    <div className={`flex flex-col lg:flex-row gap-3 px-4 mx-auto w-full justify-evenly`} >
                        <div className="lg:w-px lg:h-full w-full h-px bg-black opacity-20"></div>

                        <ul className="flex list-outside ml-8 list-disc flex-col gap-3">
                            <li className="text-lg font-semibold leading-relaxed">
                                Proposal and document generation automation.
                            </li>
                            <li className="text-lg font-semibold leading-relaxed">
                                Client onboarding and intake automation.
                            </li>
                        </ul>
                    </div>

                    {/* Column 3 */}
                    <div className={`flex flex-col lg:flex-row gap-3 px-4 mx-auto w-full justify-evenly`} >
                        <div className="lg:w-px lg:h-full w-full h-px bg-black opacity-20"></div>

                        <ul className="flex list-outside ml-8 list-disc flex-col gap-3">
                            <li className="text-lg font-semibold leading-relaxed">
                                Recruiting and candidate screening automation.
                            </li>
                            <li className="text-lg font-semibold leading-relaxed">
                                Sales pipeline and follow-up automations.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="flex flex-col md:flex-row mt-5 lg:mt-16 mx-auto gap-5">
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={"https://calendly.com/salesbox-meet/ai-ondemand"}
                        className="bg-transparent mx-auto hover:bg-brand-green hover:text-white border border-black hover:border-brand-green text-black font-medium px-6 py-3 rounded-full transition-all duration-200"
                    >
                        Book a Demo
                    </a>
                </div>
            </div>
        </section>
    );
}

export default TurnkeyGrowthSolutions;